module.exports = __webpack_public_path__ + "ProximaNova-Regular.7ce6760.ttf";